import axios from 'axios';
import Cookies from 'js-cookie';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(Cookies.get('authToken') || '');
    const navigate = useNavigate();

    const loginAction = useCallback(
        async (data) => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}auth/token/`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-APP-ID': 'CASH_APP',
                        },
                    }
                );

                const parsed = response.data;

                if (parsed?.access) {
                    setToken(parsed.access);
                    Cookies.set('authToken', parsed.access, { sameSite: 'strict' });
                    Cookies.set('refreshToken', parsed.refresh, { sameSite: 'strict' });
                    navigate('/shift');
                    return null;
                }

                return response.status;
            } catch (error) {
                // Повертаємо код, щоб екран входу міг відрізнити невірний
                // пароль (401) від недоступного сервера.
                return error.response?.status ?? 0;
            }
        },
        [navigate]
    );

    const logOut = useCallback(() => {
        setToken('');
        Cookies.remove('authToken');
        Cookies.remove('refreshToken');
        Cookies.remove('ShiftId');
        // Було: navigate("/login") — такого маршруту в застосунку немає,
        // і після виходу користувач бачив порожній екран.
        navigate('/authorization', { replace: true });
    }, [navigate]);

    const value = useMemo(() => ({ token, loginAction, logOut }), [token, loginAction, logOut]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;

export const useAuth = () => useContext(AuthContext);
